// extracted by mini-css-extract-plugin
export var cartItem = "_s-3";
export var drawerContent = "_s-0";
export var emptyCart = "_s-2";
export var fadeIn = "_s-4";
export var imagePlaceholder = "_s-6";
export var itemImage = "_s-5";
export var itemsContainer = "_s-1";